import sal from "sal.js"
import "sal.js/dist/sal.css"

export const onRouteUpdate = () => {
  sal({ threshold: 0.1, once: false })
}
